<template>
  <div class="col-12 quick-v-attr-select">
    <span class="attr-title">
          {{attributeGroup.attributeGroupName}}
        </span>
    <div class="attr-prop">
      <button
        v-for="attribute in attributeGroup.attributes"
        :key="attribute.attributeId"
        class="attr-btn-color"
        v-on:click="setSelected(attribute.attributeId)"
        :style="'background:'+ attribute.attributeDisplayValue">
        <span><i :class="selected === attribute.attributeId ? 'lni lni-checkmark' : 'lni'"></i></span>
      </button>
    </div>
  </div>

</template>

<script>
export default {
  name: 'AttributeHexSelector',
  props: ['attributeGroup'],
  data () {
    return {
      version: '0.0.2',
      selected: null
    }
  },
  computed: {
    getSelectedText () {
      if (!this.selected) {
        return ''
      }
      let selected = this.attributeGroup.attributes.find(item => item.attributeId === this.selected)
      if (!selected) {
        return ''
      }
      return selected.attributeName
    }
  },
  methods: {
    setSelected (attributeId) {
      this.selected = attributeId
      this.$emit('attribute-clicked', attributeId)
    }
  }
}
</script>

<style lang="scss" scoped>
.lni {
  min-width: 15px;
}
</style>
